<template>
<div id="chartModal" class="ui basic large long modal" style="min-height:90vh;">
  <div v-if="product" class="header">
    <img v-if="product" :src="product.largeImageUrl" class="ui image medium" style="max-height: 75px; max-width: 75px; height: auto; width: auto; border-radius:3px; float:left; margin-right:20px; margin-top:10px;">
    Sales data for {{product.productTitle}}
  </div>
  <div style="clear:both; height:10px;"></div>
  <spreadsheet-download-widget variant="sales"    :chartLastLoadedAt="lastLoadedAt" :product="product"/>

  <div class="ui inverted mini form stts21kdfslds" style="float:right;margin-right:40px;">
    <transition name="fadeDown" mode="out-in">
    <div v-if="!showChartRangeSelector" :key="1">
      Currently showing: Last 30 days - <span class="ui compact mini button" @click="showChartRangeSelector=true">Select Date</span>
    </div>
        <div class="inline field" :class="{'error' : chartRangeSt==='RANGE_ERROR'}" v-if="showChartRangeSelector" :key="2">
          <input v-model="chartRangeDateFrom" name="datefrom" type="date" placeholder="yyyy-mm-dd" style="width:125px;padding:6px;margin-top:-3px;">
          <input v-model="chartRangeDateTo"   name="dateto"   type="date" placeholder="yyyy-mm-dd" style="width:125px;padding:6px;margin-top:-3px;">
           &nbsp;
          <span class="ui compact small button" :class="{'loading' : chartRangeSt==='LOADING'}" @click="dateRangeButtonClick">Go</span>
        </div>
    </transition>
  </div>

  <div v-if="product" class="content">
    <p style="margin-top:20px;min-height:400px">
      <line-chart ref="salesLineChart"></line-chart>
      <div v-if="salesLoading" class="ui loader"></div>
    </p>
  </div>
  
  <div class="actions">
    hit ESC or click
    <div class="ui inverted ok button">OK</div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import LineChart from './LineChart'
import SpreadsheetDownloadWidget from './SpreadsheetDownloadWidget'
export default {
  components: { LineChart, SpreadsheetDownloadWidget },
  data: function () {
    const nowDateString = new Date(Date.now()).toISOString().split('T')[0]
    return {
      showChartRangeSelector: false,
      chartRangeDateFrom: nowDateString,
      chartRangeDateTo: nowDateString,
      chartRangeSt: '',
      salesLoading: true,
      promotionsLoading: true,
      promotionsColors: [
        'rgba(171,201,205,0.8)',
        'rgba(101,142,147,0.8)',
        'rgba(122,190,128,0.8)',
        'rgba(69,149,76,0.8)',
        'rgba(255,189,189,0.8)',
        'rgba(112,126,96,0.8)',
        'rgba(110,96,126,0.8)',
        'rgba(141,105,105,0.8)',
        'rgba(105,141,105,0.8)',
        'rgba(105,141,141,0.8)',
      ],
      visible: false,
      product: null,
      sourceModal: null,
      lookbackDays: 30,
      lastLoadedAt: null,
    }
  },
  methods: {
    createDataSet: function (color) {
      return {
        backgroundColor: color,
        pointBorderColor: color,
        pointBackgroundColor: color,
        borderColor: color,
        pointHoverBackgroundColor: 'black',
        pointHitRadius: 30,
        fill: false,
      }
    },
    formatDate: function (item) {
      return new Date(item.year, item.month - 1, item.day).toLocaleDateString('en-GB', {year: 'numeric', month: 'short', day: 'numeric'})
    },
    filterOutStepWithFraction: function (value, index, values) {
      if (Math.floor(value) === value) {
        return value
      }
    },
    loadSalesChart: function () {
      this.$http.get('/api/order/daily-breakdown', {
        params: {
          productGroupId: this.product.productGroupId,
          productId: this.product.productId,
          lookbackDays: this.lookbackDays,
        }
      }).then((orderResponse) => {
        this.salesLoading = false
        const hasRanks = false
        const dates = orderResponse.body.sales.map(this.formatDate)
        const ranksMap = {}
        const ranks = []
        // Rank data is no longer fetched
          const datasets = []
          if (orderResponse.body.hasVariations) {
            datasets.push($.extend(this.createDataSet('#7a969b'), {
              yAxisID: 'y-axis-0',
              label: 'Sales (all variations)',
              data: orderResponse.body.sales.map(s => s.soldUnitsAllVariations),
            }))
            datasets.push($.extend(this.createDataSet('#B0CA65'), {
              yAxisID: 'y-axis-0',
              label: 'Sales (this variation)',
              hidden: true,
              data: orderResponse.body.sales.map(s => s.soldUnitsThisVariation),
            }))
          } else {
            datasets.push($.extend(this.createDataSet('#7a969b'), {
              yAxisID: 'y-axis-0',
              label: 'Sales',
              data: orderResponse.body.sales.map(s => s.soldUnitsAllVariations),
            }))
          }
          if (hasRanks) {
            datasets.push($.extend(this.createDataSet('rgba(211, 165, 133, 0.5)'), {
              yAxisID: 'y-axis-1',
              label: orderResponse.body.hasVariations ? 'Rank (this variation)' : 'Rank',
              hidden: orderResponse.body.hasVariations,
              data: ranks,
              spanGaps: false,
            }))
          }
          const dataset = {
            datasets: datasets,
            labels: dates,
          }
          const yAxes = [{
            yAxisID: 'y-axis-0',
            scaleLabel: {
              display: true,
              labelString: 'Units Sold'
            },
            ticks: {
              beginAtZero: true,
              suggestedMax: (hasRanks ? 1.6 : 1.05) * orderResponse.body.sales.map(s => s.soldUnitsAllVariations).concat([1]).reduce(this.maxReducer),
              callback: this.filterOutStepWithFraction,
            },
            gridLines: {
              display: true,
              color: 'rgba(128, 128, 128, 0.2)'
            }
          }]
          if (hasRanks) {
            yAxes.push({
              yAxisID: 'y-axis-1',
              scaleLabel: {
                display: true,
                labelString: 'BSR'
              },
              ticks: {
                beginAtZero: false,
                reverse: true,
                suggestedMax: 1.6 * ranks.concat([1]).reduce(this.maxReducer),
                callback: this.filterOutStepWithFraction,
              },
              gridLines: {
                display: false
              },
              position: 'right',
            })
          }
          const options = {
            scales: {
              yAxes: yAxes,
              xAxes: [{
                gridLines: {
                  display: false
                }
              }]
            },
            legend: {
              display: true,
              position: 'bottom',
            },
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: 'Sales'
            }
          }
          if (this.visible) this.$refs.salesLineChart.render(dataset, options)
          $('#chartModal').modal('refresh')
      }, (orderResponse) => {
        console.log(orderResponse.body)
      })
    },
    maxReducer: (prev, current) => (prev > current) ? prev : current,
    loadPromotionsChart: function () {
      this.$http.get('/api/order/promotions-daily-breakdown', {
        params: {
          productGroupId: this.product.productGroupId,
          lookbackDays: this.lookbackDays,
        }
      }).then((promoResponse) => {
        this.promotionsLoading = false
        const promotions = promoResponse.body.promotions
        const promotionKeys = Object.keys(promotions)
        const datasets = []
        for (let i = 0; i < promotionKeys.length; ++i) {
          const promotion = promotionKeys[i]
          datasets.push($.extend(this.createDataSet(this.promotionsColors[i % this.promotionsColors.length]), {
            label: promotion,
            data: promotions[promotion],
          }))
        }
        const options = {
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Number of Used Promotions'
              },
              ticks: {
                beginAtZero: true,
                suggestedMax: 1.05 * Object.values(promotions).filter(p => p.length > 0).map(p => p.reduce(this.maxReducer)).concat([1]).reduce(this.maxReducer),
                callback: this.filterOutStepWithFraction,
              },
              gridLines: {
                display: true,
                color: 'rgba(128, 128, 128, 0.2)'
              }
            }],
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true,
            position: 'bottom',
          },
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: 'Promotions',
          }
        }
        const dataset = {
          datasets: datasets,
          labels: promoResponse.body.dates.map(this.formatDate),
        }
        if (this.visible) this.$refs.promotionsLineChart.render(dataset, options)
        $('#chartModal').modal('refresh')
      }, (promoResponse) => {
        console.log(promoResponse)
      })
    },
    open: function (product, sourceModal) {
      this.product = product
      this.sourceModal = sourceModal
    },
    dateRangeButtonClick: function () {
      if (String(this.chartRangeDateFrom).match(/^20\d{2}-[01]\d-[0123]\d$/) === null || String(this.chartRangeDateTo).match(/^20\d{2}-[01]\d-[0123]\d$/) === null) {
        this.chartRangeSt = 'RANGE_ERROR'
        setTimeout(() => { if (this.chartRangeSt === 'RANGE_ERROR') this.chartRangeSt = '' }, 2000)
        return
      }
      this.chartRangeSt = 'LOADING' // ez a sor lehet nem is kell, a chartnak ugyis van loading indicatorja

      // @TODO : Ide jon a tobbi chart loading logika
    },
  },
  watch: {
    product: function (val) {
      if (val) {
        $('#chartModal').modal({
          onVisible: () => {
            this.visible = true
            this.lastLoadedAt = Date.now()
            this.loadSalesChart()
            $('.ui.dimmer.modals').css('background-color', 'rgba(0,0,0,0.9)')
          },
          onHidden: () => {
            this.visible = false
            this.salesLoading = true
            if (this.$refs.salesLineChart && this.$refs.salesLineChart._chart) this.$refs.salesLineChart._chart.destroy()
            this.product = null
            if (this.sourceModal) $('#' + this.sourceModal).modal('show')
            $('.ui.dimmer.modals').css('background-color', '')
          },
        }).modal('show')
      }
    },
    destroyed: function () {
      $(this.$el).remove()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ProductDetailsChartModal.vue?473bdf43